import * as React from 'react';
import { deleteTimeStreamProject, TimeStreamProject } from 'owa-timestream-store';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { KeyCodes } from '@fluentui/react/lib/Utilities';
import {
    deleteSpaceTitle,
    deleteSpaceText,
} from './useConfirmAndDeleteOutlookSpace.locstring.json';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import { deleteLabel } from 'owa-locstrings/lib/strings/deletelabel.locstring.json';
import loc from 'owa-localize';

export default function useConfirmAndDeleteOutlookSpace(
    { name, projectId }: TimeStreamProject,
    onProjectDeleted?: () => void
) {
    return React.useCallback(
        (e?: React.SyntheticEvent<any, any>) => {
            if ((e as React.KeyboardEvent<any>).which) {
                if ((e as React.KeyboardEvent<any>).which !== KeyCodes.del) {
                    // if keyboard event, only delete if key is delete key
                    return;
                }
            }

            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            const title = loc(deleteSpaceTitle);
            const text = loc(deleteSpaceText, name);
            const okText = loc(deleteLabel);
            const cancelText = loc(cancelButton);

            confirm(title, text, false, {
                okText,
                cancelText,
                focusOnCancel: true,
                /** prevents calling until after confirmation dialog finishes unmounting; otherwise dialog focusTrapZone steals focus incorrectly */
                delayCallbackAfterAnimation: true,
            }).then(response => {
                if (response == DialogResponse.ok) {
                    deleteTimeStreamProject(projectId);
                    onProjectDeleted?.();
                }
            });
        },
        [name, projectId]
    );
}
